import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import img from '../../images/WeAre.png';
import img_1 from '../../images/37057.webp';

function Welcome_Article() {
    return (
        <Container className='my-5'>
            <Row className='d-flex justify-content-center'>
                <Col md={12}>
                    <Row className='align-items-center'>
                        <Col lg={6} sm={12}>
                            <h1 className='fw-bold text-primary'>WE ARE</h1>
                            <h1 className='fw-bold text-base'>OZVASERVICE </h1>
                            <p>Ozva Services is your trusted partner in transforming ideas into impactful digital solutions. With a strong presence in Australia and a reputation for excellence, we specialize in delivering innovative services that empower businesses to thrive in today’s digital age.</p>
                            {/* <h5 className='fw-bold text-base'>OZVASERVICE </h5> */}
                            <p>Our team of creative professionals, technical experts, and marketing strategists works collaboratively to craft custom solutions tailored to your business needs. From designing modern websites to launching high-performing marketing campaigns, we ensure your brand stands out and succeeds online.</p>
                            <p>We pride ourselves on our commitment to quality, transparency, and results. With offices across Sydney, Adelaide, and Baulkham Hills, we’re here to support your business growth — locally and globally.</p>

                        </Col>
                        <Col lg={6} sm={12}>
                            <img src={img} style={{ height: "424px", alignContent: "end" }} className='img-fluid rounded w-100' />
                        </Col>
                    </Row>
                    <div className="mt-5">
                        <Row className='align-items-center'>
                            <Col lg={6} sm={12}>
                                <div>
                                    <img src={img_1} style={{ height: "424px", alignContent: "end" }} className='img-fluid rounded w-100' />
                                </div>
                            </Col>
                            <Col lg={6} sm={12}>
                                <div>
                                    <h1 className='fw-bold text-base'>WE WORK WITH</h1>
                                    <p>We collaborate with businesses of all sizes to build strong digital foundations through:</p>
                                    <ul>
                                        <li>Strategic marketing campaigns</li>
                                        <li>Scalable web and mobile applications</li>
                                        <li>Engaging and SEO-friendly content</li>
                                        <li>Eye-catching design experiences</li>
                                    </ul>
                                    <p>Whether you're a startup looking to launch or an established company aiming to scale, Ozva Services provides the tools and expertise to get you there faster.</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Welcome_Article